export const VERDICT_COLOR = { BUY: "var(--accent)", SELL: "var(--negative)", HOLD: "var(--text-3)", OWN: "#7DD3FC" };
export const POS_COLORS = { QB: "#0284C7", RB: "#16A34A", WR: "#7C3AED", TE: "#D97706" };
export const LEVEL_COLOR = { Critical: "var(--negative)", Elevated: "var(--amber)", Stable: "var(--text-3)" };
